/*====== Define import ======*/
/*------ Amplify ------*/
import Amplify, { I18n } from 'aws-amplify';
/*------ Compornent Js/Jsx ------*/
import { cognitoConstants } from './constantsAuth';
import { COGNITO_ERROR } from './constantsI18n';
/*------ Etc ------*/
import dotenv from "dotenv";	//環境変数から情報取得用

/*====== Define global variables/functions   ======*/
const consoleLogOutput = false;	//コンソールログ個別出力制御用

/*------ 環境変数から情報取得 ------*/
dotenv.config();
consoleLogOutput && (console.log('■COGNITO REGION:' + process.env.REACT_APP_REGION, consoleLogOutput));
consoleLogOutput && (console.log('■COGNITO USERPOOL ID:' + process.env.REACT_APP_USERPOOLID, consoleLogOutput));
consoleLogOutput && (console.log('■COGNITO CLIENT ID:' + process.env.REACT_APP_USERPOOLWEBCLIENTID, consoleLogOutput));
consoleLogOutput && (console.log('■API ENDPOINT1 NAME:' + process.env.REACT_APP_API_ENDPOINT1_NAME, consoleLogOutput));
consoleLogOutput && (console.log('■API ENDPOINT1 URL:' + process.env.REACT_APP_API_ENDPOINT1_URL, consoleLogOutput));

if (typeof process.env.REACT_APP_REGION == 'undefined') {
	consoleLogOutput && (console.log('Error: "REGION" is not set.', consoleLogOutput, "e"));
}
if (typeof process.env.REACT_APP_USERPOOLID == 'undefined') {
	consoleLogOutput && (console.log('Error: "USERPOOLID" is not set.', consoleLogOutput, "e"));
}
if (typeof process.env.REACT_APP_USERPOOLWEBCLIENTID == 'undefined') {
	consoleLogOutput && (console.log('Error: "USERPOOLWEBCLIENTID" is not set.', consoleLogOutput, "e"));
}
if (typeof process.env.REACT_APP_API_ENDPOINT1_NAME == 'undefined') {
	consoleLogOutput && (console.log('Error: "REACT_APP_API_ENDPOINT1_NAME" is not set.', consoleLogOutput, "e"));
}
if (typeof process.env.REACT_APP_API_ENDPOINT1_URL == 'undefined') {
	consoleLogOutput && (console.log('Error: "REACT_APP_API_ENDPOINT1_URL" is not set.', consoleLogOutput, "e"));
}
// if (typeof process.env.REACT_APP_API_ENDPOINT2_NAME == 'undefined') {
// 	outputLog('Error: "REACT_APP_API_ENDPOINT2_NAME" is not set.', consoleLogOutput, "e");
// }
// if (typeof process.env.REACT_APP_API_ENDPOINT2_URL == 'undefined') {
// 	outputLog('Error: "REACT_APP_API_ENDPOINT2_URL" is not set.', consoleLogOutput, "e");
// }
// if (typeof process.env.REACT_APP_API_ENDPOINT3_NAME == 'undefined') {
// 	outputLog('Error: "REACT_APP_API_ENDPOINT3_NAME" is not set.', consoleLogOutput, "e");
// }
// if (typeof process.env.REACT_APP_API_ENDPOINT3_URL == 'undefined') {
// 	outputLog('Error: "REACT_APP_API_ENDPOINT3_URL" is not set.', consoleLogOutput, "e");
// }

/*====================*/
/*====== Main ======*/
/*====================*/
export function prepareAmplify() {

	/*------ Cognito接続情報設定 ------*/
	Amplify.configure({
		Auth: {
			region: process.env.REACT_APP_REGION,
			userPoolId: process.env.REACT_APP_USERPOOLID,
			userPoolWebClientId: process.env.REACT_APP_USERPOOLWEBCLIENTID
		},
		API: {
			endpoints: [
				{
					name: process.env.REACT_APP_API_ENDPOINT1_NAME,
					endpoint: process.env.REACT_APP_API_ENDPOINT1_URL,
				},
				//endpointが複数ある場合はここに記述

			],
		}
	});

	/*------ Cognitoからのメッセージを日本語化 ------*/
	I18n.putVocabularies(COGNITO_ERROR);
	I18n.setLanguage('ja');
	Amplify.configure(cognitoConstants);

};
